import React from 'react';
import { useSelector } from 'react-redux';

/**
 * Use Asset-types for Current Organisation Hook
 */
export default () => {
  const { typesList, userOrganisations } = useSelector((state) => state);

  const next = React.useMemo(() => {
    if (userOrganisations.item) {
      const { assetTypes, organisationAssetTypes } = typesList;
      const assetTypeIds = organisationAssetTypes.data
        .filter((item) => item.organisationId === userOrganisations.item.id)
        .map((item) => item.assetTypeId)
      ;
      return assetTypes.data.filter(({ id }) => assetTypeIds.includes(id));
    }
    return [];
  }, [typesList, userOrganisations]);

  return next;
};
